/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Preview_Noresourcestitle2Inputs */

const zh_preview_noresourcestitle2 = /** @type {(inputs: Preview_Noresourcestitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`暂无资源`)
};

const en_preview_noresourcestitle2 = /** @type {(inputs: Preview_Noresourcestitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No resources yet`)
};

const es_preview_noresourcestitle2 = /** @type {(inputs: Preview_Noresourcestitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sin recursos aún`)
};

/**
* | output |
* | --- |
* | "No resources yet" |
*
* @param {Preview_Noresourcestitle2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const preview_noresourcestitle2 = /** @type {((inputs?: Preview_Noresourcestitle2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Preview_Noresourcestitle2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_preview_noresourcestitle2(inputs)
	if (locale === "en") return en_preview_noresourcestitle2(inputs)
	return es_preview_noresourcestitle2(inputs)
});
export { preview_noresourcestitle2 as "preview_noResourcesTitle" }